var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "profile-form",
      class: {
        "name-invalid": _vm.isSubmitted && _vm.nameError,
        "positions-invalid": _vm.isSubmitted && _vm.positionsError,
      },
    },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col col-12 col-md-4 col-xl-3 profile-form__name" },
          [
            _c(
              "div",
              {
                staticClass: "form-group",
                class: {
                  "is-invalid": _vm.isSubmitted && _vm.nameError,
                },
              },
              [
                _c("c-input", {
                  attrs: {
                    "floating-label": "Наименование",
                    "required-mark": true,
                    clearable: true,
                    required: _vm.isSubmitted && _vm.nameError,
                    "required-message": _vm.isSubmitted && _vm.nameError,
                  },
                  model: {
                    value: _vm.form.name,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "name", $$v)
                    },
                    expression: "form.name",
                  },
                }),
              ],
              1
            ),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "col col-12 col-md-6 col-xl-6 profile-form__positions",
          },
          [
            _c(
              "div",
              {
                staticClass: "form-group",
                class: {
                  "is-invalid": _vm.isSubmitted && _vm.positionsError,
                },
              },
              [
                _c("c-input", {
                  attrs: {
                    type: "select",
                    "floating-label": "Должности",
                    "required-mark": true,
                    searchable: true,
                    items: _vm.collections.positions,
                    multiple: true,
                    "required-message": _vm.isSubmitted && _vm.positionsError,
                    required: _vm.isSubmitted && _vm.positionsError,
                  },
                  model: {
                    value: _vm.form.positions,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "positions", $$v)
                    },
                    expression: "form.positions",
                  },
                }),
              ],
              1
            ),
          ]
        ),
        _c("div", { staticClass: "col profile-form__actions" }, [
          _c("div", { staticClass: "form-group" }, [
            _c(
              "div",
              { staticClass: "profile-form__actions-container" },
              [
                _c("c-button", {
                  staticClass: "profile-form__reset",
                  attrs: {
                    label: "Сбросить",
                    size: "large",
                    disabled: _vm.pending,
                  },
                  on: { click: _vm.reset },
                }),
                _c("c-button", {
                  staticClass: "profile-form__save",
                  attrs: {
                    label: "Сохранить",
                    color: "primary",
                    size: "large",
                    disabled: _vm.pending,
                  },
                  on: { click: _vm.submit },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }